import { render, staticRenderFns } from "./CookieConsentBannerAccordion.vue?vue&type=template&id=22d25068&scoped=true"
import script from "./CookieConsentBannerAccordion.vue?vue&type=script&lang=ts"
export * from "./CookieConsentBannerAccordion.vue?vue&type=script&lang=ts"
import style0 from "./CookieConsentBannerAccordion.vue?vue&type=style&index=0&id=22d25068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d25068",
  null
  
)

export default component.exports